var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78121 1.63333C5.80279 1.59413 5.8345 1.56145 5.87302 1.53868C5.91154 1.51592 5.95547 1.50391 6.00021 1.50391C6.04496 1.50391 6.08888 1.51592 6.1274 1.53868C6.16593 1.56145 6.19763 1.59413 6.21921 1.63333L7.69521 4.43533C7.73041 4.50021 7.77954 4.55649 7.83907 4.60014C7.8986 4.64378 7.96705 4.67371 8.03951 4.68776C8.11198 4.70181 8.18665 4.69965 8.25818 4.68142C8.32971 4.66319 8.39631 4.62935 8.45321 4.58233L10.5917 2.75033C10.6328 2.71694 10.6834 2.69744 10.7362 2.69463C10.789 2.69182 10.8414 2.70585 10.8858 2.7347C10.9301 2.76355 10.9642 2.80573 10.983 2.85517C11.0019 2.90461 11.0046 2.95876 10.9907 3.00983L9.57371 8.13283C9.54479 8.23766 9.48247 8.33021 9.39622 8.39644C9.30996 8.46266 9.20446 8.49896 9.09571 8.49983H2.90521C2.79638 8.49907 2.69077 8.46282 2.60441 8.39658C2.51805 8.33035 2.45566 8.23774 2.42671 8.13283L1.01021 3.01033C0.996337 2.95926 0.999023 2.90511 1.01788 2.85567C1.03674 2.80623 1.0708 2.76405 1.11516 2.7352C1.15952 2.70635 1.21189 2.69232 1.26473 2.69513C1.31757 2.69794 1.36816 2.71744 1.40921 2.75083L3.54721 4.58283C3.60411 4.62985 3.67072 4.66369 3.74224 4.68192C3.81377 4.70015 3.88845 4.70231 3.96091 4.68826C4.03338 4.67421 4.10183 4.64428 4.16136 4.60064C4.22089 4.55699 4.27001 4.50071 4.30521 4.43583L5.78121 1.63333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5H9.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.d9a312c22c7cfc0bfdb00710bf77f4ed.svg";
export { ForwardRef as ReactComponent };